// @flow
import React, { Component } from 'react';
import type Store from 'redux';
import { Provider } from 'react-redux';
import configureStore from './store';
import LoadTileJSON from './load-tile-json';
import SeatcrawlerMap from './seatcrawler-map';
import { updateAPIProps } from './modules/map';
import type {
  PublicState,
  State as ReduxState,
  Listing as ListingType,
} from './types';

export type Props = PublicState;
export type Listing = ListingType;

type State = {
  store: Store<ReduxState>,
};

class Viewer extends Component<Props, State> {
  constructor(props: Props, ...args: Array<any>) {
    super(props, ...args);

    this.state = {
      store: configureStore(props),
    };
  }

  componentWillReceiveProps(props: Props) {
    this.state.store.dispatch(updateAPIProps(props));
  }

  render() {
    return (
      <Provider store={this.state.store}>
        <LoadTileJSON>
          <SeatcrawlerMap />
        </LoadTileJSON>
      </Provider>
    );
  }
}

export default Viewer;



// WEBPACK FOOTER //
// ./src/index.js